/* @flow */
const locationColumns: Array<*> = [
  {
    title: 'general:location_plural',
    expandable: true,
    blankText: '',
    linkText: 'general:actions.add_new_company',
    placeholder: 'general:placeholders.search_companies',
    action: 'addNewCompany',
    pathChooser: 'company',
  },
  {
    title: 'general:country_plural',
    expandable: false,
    blankText: 'general:locations.messages.view_countries',
    linkText: 'general:actions.add_new_site',
    placeholder: 'general:placeholders.search_countries',
    action: 'addNewSite',
    pathChooser: 'country',
  },
  {
    title: 'general:locations.labels.site_plural',
    expandable: true,
    blankText: 'general:locations.messages.view_sites',
    linkText: 'general:actions.add_new_site',
    placeholder: 'general:placeholders.search_sites',
    action: 'addNewSite',
    pathChooser: 'site',
  },
  {
    title: 'general:locations.labels.building_transport_plural',
    expandable: true,
    blankText: 'general:locations.messages.view_buildings',
    linkText: 'general:actions.add_new_building_transport',
    placeholder: 'general:placeholders.search_building_transport',
    action: 'addNewBuilding',
    pathChooser: 'building',
  },
  {
    title: 'general:locations.labels.lab_room_plural',
    expandable: true,
    blankText: 'general:locations.messages.view_rooms',
    linkText: 'general:actions.add_new_lab_room',
    placeholder: 'general:placeholders.search_lab_room',
    action: 'addNewRoom',
    pathChooser: 'room',
  },
  {
    title: 'general:locations.labels.system_workspace_plural',
    expandable: true,
    blankText: 'general:locations.messages.view_systems',
    linkText: 'general:actions.add_new_system_workspace',
    placeholder: 'general:placeholders.search_system_workspace',
    action: 'addNewSystem',
    pathChooser: 'workspace',
  },
];

export default locationColumns;
